var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import RadioGroupV2 from "./RadioGroupV2";
import { HintText, Label, Message, MessagesGroup } from "../../Form";
import { Input } from "../../Form";
import RadioRichPictogram from "./RadioRichPictogram";
import RadioRichImg from "./RadioRichImg";
import { Artwork } from "../../../technical-fundamental/Artwork";
var RadioControl = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, label = _a.label, hintText = _a.hintText, _b = _a.radioSize, radioSize = _b === void 0 ? "md" : _b, state = _a.state, messages = _a.messages, _c = _a.disabled, disabled = _c === void 0 ? false : _c, image = _a.image, svg = _a.svg, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "name", "label", "hintText", "radioSize", "state", "messages", "disabled", "image", "svg", "className", "style"]);
    var idMessages = id + "-messages";
    return (React.createElement(RadioGroupV2, { size: radioSize, isRich: !!svg || !!image, state: disabled ? "disabled" : state },
        React.createElement(Input, __assign({}, otherProps, { type: "radio", id: id, name: name, disabled: disabled, className: className, style: style, ref: ref, "aria-describedby": idMessages })),
        React.createElement(Label, { htmlFor: id },
            label,
            React.createElement(HintText, null, hintText ? hintText : " ")),
        image ? React.createElement(RadioRichImg, null, image) : undefined,
        svg ? (React.createElement(RadioRichPictogram, null,
            React.createElement(Artwork, { svg: svg, size: "5rem" }))) : undefined,
        React.createElement(MessagesGroup, { id: idMessages }, messages && state
            ? messages.map(function (message) { return React.createElement(Message, { state: state }, message); })
            : undefined)));
});
export default RadioControl;
